// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3Zf9z","overflowing":"ReadFullNote_overflowing__2V5l1"};